export enum RankTypeEnum {
  GROUPS = 'groups',
  VEHICLES = 'vehicles',
  DRIVERS = 'drivers'
}
